"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireWildcard(require("react"));
var _inputValidationMessage = require("../input-validation-message");
var _fieldBase = _interopRequireDefault(require("../field-base"));
var _icon = _interopRequireDefault(require("../icon"));
var _animator = _interopRequireDefault(require("../animator"));
var _caretDownCircleSolid = _interopRequireDefault(require("../../icons/caret-down-circle-solid"));
var _caretDownCircle = _interopRequireDefault(require("../../icons/caret-down-circle"));
var _wrapWithRequiredAsterisk = _interopRequireDefault(require("../../utils/wrap-with-required-asterisk"));
require("./select-base.css");
var _excluded = ["children", "className", "customFieldStatus", "displayStatus", "enableValidationMessage", "error", "errorMessage", "floatLabelAriaHidden", "hintText", "id", "useInactiveStyle", "label", "modified", "onBlur", "onFocus", "required", "selectedOptionFormatter", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    customFieldStatus = _ref.customFieldStatus,
    displayStatus = _ref.displayStatus,
    enableValidationMessage = _ref.enableValidationMessage,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    floatLabelAriaHidden = _ref.floatLabelAriaHidden,
    hintText = _ref.hintText,
    id = _ref.id,
    _ref$useInactiveStyle = _ref.useInactiveStyle,
    useInactiveStyle = _ref$useInactiveStyle === void 0 ? false : _ref$useInactiveStyle,
    label = _ref.label,
    modified = _ref.modified,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    required = _ref.required,
    selectedOptionFormatter = _ref.selectedOptionFormatter,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var handleFocus = function handleFocus(ev) {
    if (onFocus) {
      onFocus(ev);
    }
    setIsFocused(true);
  };
  var handleBlur = function handleBlur(ev) {
    if (onBlur) {
      onBlur(ev);
    }
    setIsFocused(false);
  };
  var getOptionValue = function getOptionValue(child) {
    if (!(child !== null && child !== void 0 && child.props)) {
      return null;
    }
    return child.props.value || child.props.children;
  };
  var getSelectedOption = function getSelectedOption() {
    // non-breaking space character to preserve space.
    var spaceChar = '\xa0';
    var currentOption = _react["default"].Children.toArray(children).find(function (child) {
      return getOptionValue(child) === value;
    });

    // if the currentOption is undefined, it means a controlled component was
    // passed down an incorrect 'value' prop
    if (!currentOption) {
      return {
        text: spaceChar,
        value: ''
      };
    } else if (selectedOptionFormatter) {
      return {
        text: selectedOptionFormatter({
          text: currentOption.props.children,
          value: currentOption.props.value
        }),
        value: value
      };
    }
    return {
      text: currentOption.props.children,
      value: value
    };
  };
  var fieldId = id || (0, _uniqueId2["default"])('select-base');
  var validationId = "".concat(fieldId, "-validationHint");
  var hintTextId = "".concat(fieldId, "-hintText");

  // verify props value is one of the current options, if not reset
  var _getSelectedOption = getSelectedOption(),
    currentValue = _getSelectedOption.value,
    currentText = _getSelectedOption.text;
  var labelIsActive = Boolean(currentValue);
  var showValidationMessage = (0, _inputValidationMessage.getDisplayStatus)({
    displayStatus: displayStatus,
    error: error,
    errorMessage: errorMessage
  });
  var ariaDescribeByIds = [showValidationMessage ? validationId : null, hintText ? hintTextId : null];
  var labelText = required ? (0, _wrapWithRequiredAsterisk["default"])({
    children: label,
    error: error
  }) : label;
  return /*#__PURE__*/_react["default"].createElement(_fieldBase["default"], {
    childId: fieldId,
    className: className,
    customFieldStatus: customFieldStatus,
    enableValidationMessage: enableValidationMessage,
    error: error,
    errorMessage: errorMessage,
    errorMessageDisplayStatus: displayStatus,
    floatLabelActive: labelIsActive,
    floatLabelAriaHidden: floatLabelAriaHidden,
    floatLabelClassName: "select__floatLabel",
    floatLabelText: labelText,
    hintText: hintText,
    hintTextId: hintTextId,
    isFocused: isFocused,
    useInactiveStyle: useInactiveStyle,
    useModifiedStyle: modified,
    validationId: validationId
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    "aria-describedby": ariaDescribeByIds.filter(Boolean).join(' '),
    "aria-invalid": error,
    "aria-required": required,
    className: "select__input",
    id: id,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: ref,
    value: currentValue
  }, otherProps), /*#__PURE__*/_react["default"].createElement("option", {
    // Use `hidden` attribute and styling to hide placeholder option
    // when `select` is open in as many browsers as possible. This
    // element is a placeholder option used to prevent the `Select`
    // from selecting the first actual option by default, because
    // our component does not always have a selected option, unlike
    // purely native select elements.
    className: "hidden",
    disabled: true,
    hidden: true,
    value: ""
  }, label), children), /*#__PURE__*/_react["default"].createElement("span", {
    // This is the element which is seen in the UI when the dropdown is
    // not actively open and shows the currently selected option.
    // It visually contains the floating label. It is hidden from
    // screenreaders as those user agents will read the actual label
    // and the selected value, if applicable.
    "aria-hidden": "true",
    className: "select__selectedTextWrapper flex justify-between relative"
  }, /*#__PURE__*/_react["default"].createElement(_animator["default"], {
    animation: "fade"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "select__selectedText absolute text-sm",
    key: currentText
  }, currentText)), labelIsActive && /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true",
    className: "invisible",
    key: currentText
  }, currentText), /*#__PURE__*/_react["default"].createElement(_animator["default"], null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "color-greenAccent caretIcon self-center ml-auto",
    key: modified ? "".concat(fieldId, "_solid") : "".concat(fieldId, "_circle"),
    path: modified ? _caretDownCircleSolid["default"] : _caretDownCircle["default"],
    size: "24px"
  }))));
});
var _default = exports["default"] = Select;